import { useState } from "react";
import KanaGrid from "@/components/app/KanaGrid";
import { useLang } from "@/context/LanguageContext";

export default function KanjiPage() {
  const { t } = useLang();
  const [level, setLevel] = useState("N5");
  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-10 flex flex-wrap gap-3 items-center">
        <div className="eyebrow !text-ink-soft">{t("jlptLevel")}</div>
        <div className="kawaii-card inline-flex gap-1 p-1.5">
          {["N5", "N4", "N3"].map((lv) => (
            <button key={lv} data-testid={`kanji-level-${lv}`} onClick={() => setLevel(lv)}
              className={`kawaii-pill-nav !text-xs ${level === lv ? "active" : ""}`}>{lv}</button>
          ))}
        </div>
      </div>
      <KanaGrid system="kanji" level={level} title={`${t("kanji")} · ${level}`} subtitle={t("kanjiSubtitle")} chartLabel={t("kanjiChart")} />
    </div>
  );
}
